import { render, staticRenderFns } from "./proc-calendar-dialog.vue?vue&type=template&id=68907672"
import script from "./proc-calendar-dialog.vue?vue&type=script&lang=js"
export * from "./proc-calendar-dialog.vue?vue&type=script&lang=js"
import style0 from "./proc-calendar-dialog.vue?vue&type=style&index=0&id=68907672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDatePicker,VDialog})
